// Validation functions for email, text, and number inputs
export const validateEmail = (email) => {
  if (email.trim() === '') {
    return 'Please fill out this field'
  }
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  return emailRegex.test(email) ? '' : 'Invalid email address'
}

export const validateName = (text) => {
  if (text.trim() === '') {
    return 'Please fill out this field'
  }
  const textRegex = /^[A-Za-z\s]+$/
  return textRegex.test(text) ? '' : 'Please enter valid full name'
}

export const validatePhoneNumber = (number) => {
  if (number.trim() === '') {
    return 'Please fill out this field'
  }
  // using regex and max 10 digits
  const numberRegex = /^[0-9]{10}$/
  return numberRegex.test(number) ? '' : 'Please enter valid phone number'
}

// Function to check if the address is complete
export const validateAddress = (province, district, ward) => {
  if (province === '' && district === '' && ward === '') {
    return 'Please enter full address'
  } else if (district === '') {
    return 'Please enter district'
  } else if (ward === '') {
    return 'Please enter ward'
  }
}

export const validateText = (text) => {
  const textRegex = /^[a-zA-Z0-9\s\-/,]+$/
  return textRegex.test(text) ? '' : 'Please fill out this field'
}

// Function to validate a field value
export const validateField = (name, value) => {
  switch (name) {
    case 'email':
      return validateEmail(value)
    case 'fullName':
      return validateName(value)
    case 'streetAddress':
      return validateText(value)
    case 'phoneNumber':
      return validatePhoneNumber(value)
    default:
      return ''
  }
}
